import React, { Component } from 'react';
import lang from '../../lang';

class LoadingTip extends Component {
    render() {
        return (
        	<div className="mini-loading">
                <div className="loading-tip">{lang.template('正在加载')}<em>.</em><em>.</em><em>.</em></div>
            </div>
        )
    }
}

export default LoadingTip;



// WEBPACK FOOTER //
// ./js/component/loading/index.js